var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3693_6291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3693_6291)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3693_6291",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 24,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 24,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3693_6291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2H27V18H3V2Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.6663V18.0002H3V16.6663H27ZM27 15.3333H3V14.0002H27V15.3333ZM27 12.6663H3V11.3333H27V12.6663ZM27 10.0002H3V8.66626H27V10.0002ZM27 7.33325H3V6.00024H27V7.33325ZM27 4.66626H3V3.33325H27V4.66626Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 13.5,
    height: 9.33333,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7161 3.46753H15.5022L14.885 4.02222L15.1243 4.89819L14.3547 4.40601L13.718 4.80054H14.0022L13.385 5.3562L13.5979 6.13452H14.0442L14.3538 5.41968L14.7161 6.13452H15.5022L14.885 6.68921L15.1243 7.56519L14.3547 7.073L13.718 7.46753H14.0022L13.385 8.02222L13.5979 8.80054H14.0442L14.3538 8.08569L14.7161 8.80054H15.5022L14.885 9.3562L15.1243 10.2322L14.3547 9.73999L13.5598 10.2322L13.8284 9.3562L13.1223 8.80054H13.4719L12.8547 8.40601L12.218 8.80054H12.5022L11.885 9.3562L12.1243 10.2322L11.3547 9.73999L10.5598 10.2322L10.8284 9.3562L10.1223 8.80054H10.4719L9.85474 8.40601L9.21802 8.80054H9.5022L8.88501 9.3562L9.12427 10.2322L8.35474 9.73999L7.55981 10.2322L7.82837 9.3562L7.12231 8.80054H7.47192L6.85474 8.40601L6.21802 8.80054H6.5022L5.88501 9.3562L6.12427 10.2322L5.35474 9.73999L4.55981 10.2322L4.82837 9.3562L4.12231 8.80054H5.04419L5.35376 8.08569L5.71606 8.80054H6.09009L6.32837 8.02222L5.62231 7.46753H5.97192L5.35474 7.073L4.55981 7.56519L4.82837 6.68921L4.12231 6.13452H5.04419L5.35376 5.41968L5.71606 6.13452H6.09009L6.32837 5.3562L5.62231 4.80054H5.97192L5.35474 4.40601L4.55981 4.89819L4.82837 4.02222L4.12231 3.46753H5.04419L5.35376 2.75269L5.71606 3.46753H6.5022L5.88501 4.02222L6.0979 4.80054H6.54419L6.85376 4.08569L7.21606 4.80054H7.59009L7.82837 4.02222L7.12231 3.46753H8.04419L8.35376 2.75269L8.71606 3.46753H9.5022L8.88501 4.02222L9.0979 4.80054H9.54419L9.85376 4.08569L10.2161 4.80054H10.5901L10.8284 4.02222L10.1223 3.46753H11.0442L11.3538 2.75269L11.7161 3.46753H12.5022L11.885 4.02222L12.0979 4.80054H12.5442L12.8538 4.08569L13.2161 4.80054H13.5901L13.8284 4.02222L13.1223 3.46753H14.0442L14.3538 2.75269L14.7161 3.46753ZM10.718 7.46753H11.0022L10.385 8.02222L10.5979 8.80054H11.0442L11.3538 8.08569L11.7161 8.80054H12.0901L12.3284 8.02222L11.6223 7.46753H11.9719L11.3547 7.073L10.718 7.46753ZM7.71802 7.46753H8.0022L7.38501 8.02222L7.5979 8.80054H8.04419L8.35376 8.08569L8.71606 8.80054H9.09009L9.32837 8.02222L8.62231 7.46753H8.97192L8.35474 7.073L7.71802 7.46753ZM12.218 6.13452H12.5022L11.885 6.68921L12.0979 7.46753H12.5442L12.8538 6.75269L13.2161 7.46753H13.5901L13.8284 6.68921L13.1223 6.13452H13.4719L12.8547 5.73999L12.218 6.13452ZM6.21802 6.13452H6.5022L5.88501 6.68921L6.0979 7.46753H6.54419L6.85376 6.75269L7.21606 7.46753H7.59009L7.82837 6.68921L7.12231 6.13452H7.47192L6.85474 5.73999L6.21802 6.13452ZM9.21802 6.13452H9.5022L8.88501 6.68921L9.0979 7.46753H9.54419L9.85376 6.75269L10.2161 7.46753H10.5901L10.8284 6.68921L10.1223 6.13452H10.4719L9.85474 5.73999L9.21802 6.13452ZM7.71802 4.80054H8.0022L7.38501 5.3562L7.5979 6.13452H8.04419L8.35376 5.41968L8.71606 6.13452H9.09009L9.32837 5.3562L8.62231 4.80054H8.97192L8.35474 4.40601L7.71802 4.80054ZM10.718 4.80054H11.0022L10.385 5.3562L10.5979 6.13452H11.0442L11.3538 5.41968L11.7161 6.13452H12.0901L12.3284 5.3562L11.6223 4.80054H11.9719L11.3547 4.40601L10.718 4.80054Z",
    fill: "#F7FCFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3693_6291",
    x: 0,
    y: 0,
    width: 30,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3693_6291"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3693_6291",
    result: "effect2_dropShadow_3693_6291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3693_6291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3693_6291"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 24,
    height: 16,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/UsFlag.2e1708e5234ad141bbdc51af1131a682.svg";
export { ForwardRef as ReactComponent };